import { useMediaQuery, useStorage } from '@vueuse/core'
import { computed, watchEffect } from 'vue'

export type Theme = 'light' | 'dark' | 'system'

const theme = useStorage<Theme>('convbased-theme', 'system')
const prefersDark = useMediaQuery('(prefers-color-scheme: dark)')

export function useTheme() {
  const resolvedTheme = computed<'light' | 'dark'>(() => {
    if (theme.value === 'system') return prefersDark.value ? 'dark' : 'light'
    return theme.value
  })

  watchEffect(() => {
    const root = document.documentElement
    const isDark = resolvedTheme.value === 'dark'
    root.classList.toggle('dark', isDark)
    root.style.colorScheme = resolvedTheme.value
    document
      .querySelector('meta[name="theme-color"]')
      ?.setAttribute('content', getComputedStyle(root).getPropertyValue('--canvas').trim())
  })

  return {
    theme,
    resolvedTheme,
    setTheme: (value: Theme) => {
      theme.value = value
    },
  }
}
